// Dev
// const BaseUrl = 'https://fi-ne-dev-bomobile-01.frenchinnov.fr';
// export const ImageBaseUrl = 'http://40.127.178.155:93/uploads/'

// Prod
const BaseUrl = 'https://backendbackoffice.frenchinnov.fr';
export const ImageBaseUrl = 'https://backendbackoffice.frenchinnov.fr/uploads/'


export const token =  "Bearer " + localStorage.getItem('Token');
export default BaseUrl; 